module.exports = __webpack_public_path__ + "static/no-hope-no-fear-1f0c3cb236c5a9f95f661eea17eb5a4d.png";